import React, { Component } from 'react';
import { Input ,Form} from 'antd';

import { Link, Redirect } from 'react-router-dom';
import { Parse } from 'parse';

import {FormattedMessage, FormattedHTMLMessage, defineMessages ,   injectIntl} from 'react-intl';

import {connect} from 'react-redux';
import updateInstallation from '../installation';
import {loginSuccess,logout} from '../store/slice/user'
import makeReduxUserFromParseUser from '../utils/makeMyUserFromParseUser';

const FormItem = Form.Item;

const messages=defineMessages({
  inputEmail:{
    id:'Login.input.email',
    defaultMessage:'Enter your e-mail'
  },
  emailRequired:{
    id:'Login.email.error.required',
    defaultMessage:'Email is required'
  },
  emailType:{
    id:'Login.email.error.Type',
    defaultMessage:'Email is not a valid email'
  },
  inputPassword:{
    id:'Login.input.password',
    defaultMessage:"Password"
  },
  passwordRequired:{
    id:'Login.password.error.required',
    defaultMessage:'Password is required'
  },
  invalid:{
    id:'Login.error.invalid',
    defaultMessage:'Invalid username/password.'
  },
});

class Login extends Component{

  constructor(props){
      super(props);

      this.state={
          email:'',
          password:'',
          errorMessage:'',
          redirectToReferrer: false
        };
        this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
        this.handlePasswordInputChange = this.handlePasswordInputChange.bind(this);
  }


  render(){
    const { getFieldDecorator, getFieldError} = this.props.form;
    const errorMessage=this.state.errorMessage;
    const userNameError = getFieldError('email');
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const {formatMessage}=this.props.intl;
    if(this.state.redirectToReferrer){
      return (
         <Redirect to={from}/>
      )
    }
    return(
      <div className="login-background">
        <div className="login-center">
          <div className="login">
              <Link to="/">
                <img className="login-bi" src={require('../img/mojitok_BI_login.png')} alt=""/>
              </Link>

              <Form onSubmit={this._handleLogin} className="login-form">
                    <FormItem validateStatus={errorMessage|| userNameError ? 'error' : ''}>
                      {getFieldDecorator('email', {
                        rules: [
                          {type:'email', message: formatMessage(messages.emailType) },
                          { required: true, message: formatMessage(messages.emailRequired) },
                        ],

                      })(
                        <Input placeholder={formatMessage(messages.inputEmail)} className="login-input" onChange={this.handleEmailInputChange}/>
                      )}
                    </FormItem>
                    <FormItem
                      validateStatus={errorMessage ? 'error' : ''}
                      help={errorMessage||''}
                    >
                      {getFieldDecorator('password', {
                        rules: [
                          { required: true, message: formatMessage(messages.passwordRequired) },
                        ],
                      })(
                        <Input type="password" placeholder={formatMessage(messages.inputPassword)} className="login-input" onChange={this.handlePasswordInputChange}/>
                      )}
                    </FormItem>
                    <FormItem>
                      <button className="login-button" type="primary" htmltype="submit">
                        Login
                      </button>
                    </FormItem>
                  </Form>
              <div className="login-others">
                <Link to="/reset" className="login-other">
                  <FormattedMessage
                    id={'Login.forgotPassword'}
                    defaultMessage={'* Forgot password?'}
                  />
                </Link>
                <br />
                <Link to="/signup" className="login-other">
                  <FormattedHTMLMessage
                    id={'Login.signUp'}
                    defaultMessage={'* Not a member? <u>Sign up now</u>'}
                  />
                </Link>
              </div>
          </div>
        </div>
      </div>
    );
  }


  handleEmailInputChange(e){
    this.setState({
      email: e.target.value
    })
  }
  handlePasswordInputChange(e){
    this.setState({
      password: e.target.value
    })
  }

  _handleLogin = (event) =>{
    const { email, password } = this.state;
    const {formatMessage} = this.props.intl;
    event.preventDefault();
    this.props.form.validateFields((err, values) => {//값이 비어있는지 검증 위해
      if (!err) {
            Parse.User.logIn(email, password)
            .then(()=> {
              updateInstallation({
                user : Parse.User.current()
              });
              this.props.loginSuccess(Parse.User.current());
              this.setState({
                redirectToReferrer: true
              });
            })
            .catch( (error)=> {
              if(error.code===101)
                this.setState({
                  errorMessage:formatMessage(messages.invalid)
                })
              else {
                this.setState({
                  errorMessage:error.message
                })
              }
              this.props.loginFailed(error);
            });

        }
    });

  }//handleLogin end

}//class Login end
Login=Form.create({})(injectIntl(Login));

const mapStateToProps = (state)=>{
  return{
    ...state.sessionReducer
  };
};

const mapDispatchToProps=(dispatch)=>{
  return{
    loginSuccess:(user)=>{
      dispatch(loginSuccess(makeReduxUserFromParseUser(user)))
    },
    loginFailed:(error)=>{dispatch(logout())}
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
 // export default Login;
